(ns minorodata.components.monaco.diff-editor
  (:require ["@monaco-editor/react" :refer [DiffEditor]]
            ["react-resize-detector" :refer [useResizeDetector]]))


(defn diff-editor [{:keys [original modified language theme options overrideServices on-change editor-will-mount editor-did-mount data-cy]
               :or   {original          ""
                      modified          ""
                      language          "sql"
                      theme             "vs-dark"
                      options           {:fontSize 10}
                      overrideServices  {}
                      editor-did-mount  (fn [] {})
                      editor-will-mount (fn [] {})}}]

  (let [{:keys [ref width height]} (js->clj (useResizeDetector #js {:handleWidth  true
                                                                    :handleHeight true
                                                                    :refreshMode  "throttle"
                                                                    :refreshRate  100})
                                            :keywordize-keys true)]

    [:div {:style {:height "100%" :width "100%"}
           :ref ref}
     [:> DiffEditor
      {:class            "cljs-monaco-diff-editor-container"
       :wrapperProps     {:data-cy data-cy}
       :style            {:height height :width width}
       :options          options
       :theme            theme
       :language         language
       :original         original
       :modified         modified
       :beforeMount      editor-will-mount
       :onMount          editor-did-mount
       :onChange         on-change
       :overrideServices overrideServices}]]))
